import React from "react";
import { Phone, MapPin, Mail, Shield } from "lucide-react";
import PageBanner from "../components/PageBanner";
import Reveal from "../components/Reveal";
import Seo from "../components/Seo";
import RealLogo from "../components/RealLogo";
import { CONTACT } from "../mock";

const Contact = () => {
  return (
    <div>
      <Seo
        title="Contact Roger Minner | Kennett Square, PA Realtor"
        description="Contact Roger Minner to buy or sell a home in Kennett Square, West Chester, PA or Chester County and Delaware County. Call, email, or send a message to schedule a consultation."
      />
      <PageBanner
        eyebrow="Let's Connect"
        title="Contact"
        subtitle="Reach out for a remarkable home selling and buying experience."
        image="https://images.unsplash.com/photo-1762694913173-29bb6e5808d4?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80"
      />

      <section className="bg-[#f6f2ed] py-20 md:py-28">
        <div className="max-w-[1000px] mx-auto px-6">
          <Reveal className="text-center">
            <p className="font-sans-el tracking-[0.4em] uppercase text-[#9a878b] text-xs mb-4">
              {CONTACT.specialist}
            </p>
            <h2 className="brand-title text-4xl md:text-5xl text-[#3a3736] uppercase">{CONTACT.name}</h2>
            <p className="font-serif-el italic text-xl text-[#6f5f62] mt-2">Realtor</p>
            <div className="divider-ornament mt-6">
              <span className="line" /><span className="dot" /><span className="line" />
            </div>
          </Reveal>

          {/* Prominent clickable phone */}
          <Reveal className="mt-12">
            <a
              href={`tel:${CONTACT.phoneRaw}`}
              className="group block bg-[#b6a4a7] rounded-sm py-12 px-6 text-center transition-all duration-300 hover:bg-[#6f5f62]"
            >
              <p className="font-sans-el tracking-[0.3em] uppercase text-white/85 text-sm mb-4">
                Call Roger Today
              </p>
              <span className="flex items-center justify-center gap-4 text-white">
                <Phone size={40} className="transition-transform duration-300 group-hover:rotate-12" />
                <span className="brand-title text-5xl md:text-7xl tracking-wide">{CONTACT.phone}</span>
              </span>
            </a>
          </Reveal>

          {/* Details */}
          <div className="grid md:grid-cols-3 gap-6 mt-8">
            <Reveal>
              <a href={`tel:${CONTACT.phoneRaw}`} className="bg-white rounded-sm p-7 flex flex-col items-center text-center h-full shadow-[0_16px_40px_-30px_rgba(58,55,54,0.4)] hover:-translate-y-1 transition-transform duration-300">
                <Phone size={26} className="text-[#b6a4a7] mb-4" />
                <p className="font-sans-el tracking-[0.2em] uppercase text-[#9a878b] text-xs mb-2">Phone</p>
                <p className="font-serif-el text-lg text-[#3a3736]">{CONTACT.phone}</p>
              </a>
            </Reveal>
            <Reveal>
              <a href={`mailto:${CONTACT.email}`} className="bg-white rounded-sm p-7 flex flex-col items-center text-center h-full shadow-[0_16px_40px_-30px_rgba(58,55,54,0.4)] hover:-translate-y-1 transition-transform duration-300">
                <Mail size={26} className="text-[#b6a4a7] mb-4" />
                <p className="font-sans-el tracking-[0.2em] uppercase text-[#9a878b] text-xs mb-2">Email</p>
                <p className="font-serif-el text-lg text-[#3a3736] break-all">{CONTACT.email}</p>
              </a>
            </Reveal>
            <Reveal>
              <div className="bg-white rounded-sm p-7 flex flex-col items-center text-center h-full shadow-[0_16px_40px_-30px_rgba(58,55,54,0.4)]">
                <MapPin size={26} className="text-[#b6a4a7] mb-4" />
                <p className="font-sans-el tracking-[0.2em] uppercase text-[#9a878b] text-xs mb-2">Office</p>
                <p className="font-serif-el text-lg text-[#3a3736]">{CONTACT.address}</p>
              </div>
            </Reveal>
          </div>

          <Reveal className="mt-14 flex flex-col items-center">
            <RealLogo dark />
            <p className="flex items-center gap-2 font-sans-el text-sm text-[#6f5f62] mt-6">
              <Shield size={16} className="text-[#b6a4a7]" /> {CONTACT.area}
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Contact;
